/**
 * Must match tradestation-server/services/tradeLifecycleStore.js buildTradeId().
 * trade_id = "${userId}|${accountId}|${symbol}|${positionTimestampIso}"
 */
export function buildTradeId(userId, accountId, symbol, positionTimestamp) {
  if (userId == null || !accountId || !symbol || !positionTimestamp) return null;
  const ts = new Date(positionTimestamp);
  if (Number.isNaN(ts.getTime())) return null;
  return `${userId}|${accountId}|${String(symbol).trim()}|${ts.toISOString()}`;
}

/** Derive trade_id from a TradeStation position snapshot (uses open Timestamp). */
export function tradeIdFromPosition(userId, position) {
  if (!position) return null;
  const ts = position.Timestamp || position.OpenDate || position.DateOpened;
  return buildTradeId(userId, position.AccountID, position.Symbol, ts);
}
